import { useEffect, useState, useCallback } from "react";
import throttle from "lodash/throttle";
import { IS_BROWSER } from "@/misc/constants";
export const useScrollSpy = (delay = 250) => {
  const [pos, setPos] = useState(0);
  const handler = useCallback(
    throttle(function () {
      setPos(this.scrollY);
    }, delay),
    []
  );
  useEffect(() => {
    if (IS_BROWSER) {
      window.addEventListener("scroll", handler);
      return () => window.removeEventListener("scroll", handler);
    }
  }, []);
  return pos;
};
